import React from 'react';
import './main.css';

export default function GenesisLanding() {
  return (
    <div className="genesis-container">
      {/* Animated background elements */}
      <div className="background-elements">
        <div className="bg-circle bg-circle-1"></div>
        <div className="bg-circle bg-circle-2"></div>
        <div className="bg-circle bg-circle-3"></div>
      </div>

      {/* Main content */}
      <div className="main-content">
        
        {/* Logo/Icon area */}
        <div className="logo-container">
          <div className="logo-glow"></div>
          <div className="logo-image">
            <img 
              src="/logo512.jpg" 
              alt="genesis AI Image Icon" 
            />
          </div>
        </div>

        {/* App name */}
        <h1 className="app-title">
          Genesis AI Image
        </h1>

        {/* Tagline */}
        <div className="tagline">
          <span className="zap-icon">⚡</span>
          <p>Unlimited magic ai image generation and editing</p>
          <span className="zap-icon">⚡</span>
        </div>

        {/* Description */}
        <p className="description">
          Upload your photos and let AI work its magic
        </p>

        {/* Feature highlights */}
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">⭐</div>
            <h3>AI Magic</h3>
            <p>Transform photos with advanced AI</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">✨</div>
            <h3>Unlimited</h3>
            <p>Unlimited AI Credits</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3>Fast Generation</h3>
            <p>Professional edits in seconds</p>
          </div>
        </div>

        {/* Download buttons */}
        <div className="download-buttons">
          {/* Google Play Button */}
          <a
            href="https://play.google.com/store/apps/details?id=com.syazwis.beauty_app"
            target="_blank"
            rel="noopener noreferrer"
            className="button-group google-play-group"
          >
            <div className="button-glow"></div>
            <div className="button-main">
              <img src="/google.png" alt="Google Play Icon" className="icon-image" />
              <div className="button-text">
                <div className="button-subtitle">GET IT ON</div>
                <div className="button-title">Google Play</div>
              </div>
            </div>
          </a>

          {/* Apple App Store Button */}
          <a
            href="https://apps.apple.com/my/app/genesis-ai-magic-ai-image/id6748695462"
            target="_blank"
            rel="noopener noreferrer"
            className="button-group app-store-group"
          >
            <div className="button-glow"></div>
            <div className="button-main">
            <img src="/apple.png" alt="apple Play Icon" className="icon-image" />
              <div className="button-text">
                <div className="button-subtitle">DOWNLOAD ON THE</div>
                <div className="button-title">App Store</div>
              </div>
            </div>
          </a>
        </div>

        {/* Floating particles effect */}
        <div className="floating-particles">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="particle"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${2 + Math.random() * 3}s`
              }}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
}